const isValidDate = (date: unknown) =>
  date instanceof Date && !Number.isNaN(date.getTime());

export default isValidDate;
